import React, { useState, useEffect } from "react";

import { AnimateOnChange } from "react-animation";
import UsuarioService from "../services/UsuarioService";
import { useHistory } from "react-router-dom";
import CampanhaService from "../services/CampanhaService";
import "./LoginRegister/LoginRegister.css";

import LoginCampaign from "./LoginRegister/LoginCampaign";
import LogosCampanha from "../comps/LogosCampanha/LogosCampanha";
import WeexMessage from "../comps/WeexMessage";
import {useStore} from 'react-redux';
import TemaService from '../services/TemaService';
import RegisterSelector from "./RegisterSelector";
import WeexModal from "../comps/weexModais/WeexModal";

function LoginRegister(props) {
	const i18n = useStore().getState().i18n
	
	
	const campanhaService = new CampanhaService();
	const usuarioService = new UsuarioService();
	const history = useHistory();
	const [campanha] = useState(campanhaService.campanhaCorrente());
	const [erro, setErro] = useState({
		isWrong: false,
		titulo: "",
		mensagem: "",
	});

	useEffect(() => {
		const temaService = new TemaService(campanhaService.campanhaCorrente())
		temaService.aplicarTema('ENTRADA')


		if (usuarioService.usuarioCorrente() && campanha) {
			campanhaService.contadorCampanha((erro, sucesso)=>{
				if(erro){
					setErro({
						isWrong: true,
						titulo: i18n.message("atividades.erro.dias.habilitados", "Erro obter lista de dias habilitados")
					});
					return;
				}
				if(sucesso){
					if(sucesso !== null){
						if(sucesso.length > 0 ){
							history.push('/atividades')
						} else {
							history.push("/home")
						}
					}
				}
			})
		}
	}, [])

	const [modo, setModo] = useState(
		campanhaService.campanhaCorrente() ? (
			campanhaService.campanhaCorrente().restrictEligibility
				? "login"
				: "register"
		) : 'notfound'
	);

	const toggleModo = () => {
		switch (modo) {
			case "register":
				setModo("login");
				break;
			case "login":
				setModo("register");
				break;
			case "notfound":
				setModo("select");
				break;
		}
	};

	if (!campanha) {
		history.push("/select")
		return null;
	}

	const callbackModal = () => {
		if (erro.isWrong === true) {
			setErro({ isWrong: false });
		}
	};

	const exporRegistro = !campanha.restrictEligibility;
	const tipoInscricao = campanha.tipoInscricao;
	const altIconeInscricao = i18n.message('registro.alt.iconeInscricao', 'Inscrição');
	return (
		<div className="weex_container">
			<LogosCampanha campanha={campanha} />

			{erro.isWrong === true ? (
				<WeexModal
					callback={callbackModal}
					visivel={erro !== null}
					titulo={erro.titulo}
					conteudo={erro.mensagem}
				/>
			) : null}

			<div className="aviso_login">
				<p className="aviso_login_chamada foreground"><WeexMessage code="registro.saudacao" default="Ol&aacute;!"/></p>
				<p className="aviso_login_subtitulo foreground">
					{exporRegistro
						? i18n.message("registro.instrucaoRegistro", "Crie sua conta para participar da campanha")
						: ""}
				</p>
			</div>

			<div className="weex_user_container">
				{exporRegistro ? (
					<div style={{ textAlign: "center", marginBottom: "1.2em" }}>
						<img
							src="/icone_inscricao.png"
							className="icone_inscricao"
							alt={{altIconeInscricao}}
						/>
						<div className="tabs is-centered">
							<ul>
								<li
									onClick={() => {
										setModo("register");
									}}
									className={modo === "register" ? "is-active" : ""}
								>
									<a><WeexMessage code="registro.action.registre" default="Registre-se"/></a>
								</li>
								<li
									onClick={() => {
										setModo("login");
									}}
									className={modo !== "register" ? "is-active" : ""}
								>
									<a><WeexMessage code="registro.action.login" default="Entrar"/></a>
								</li>
							</ul>
						</div>
					</div>
				) : null}

				<AnimateOnChange style={{ width: "100%" }}>
					{modo === "register" ? (
						<RegisterSelector
							callbackLogin={props.callbackLogin}
							toggleModo={toggleModo}
							campanha={campanha}
						/>
					) : (
						<LoginCampaign
							callbackLogin={props.callbackLogin}
							toggleModo={toggleModo}
							campanha={campanha}
						/>
					)}
				</AnimateOnChange>
			</div>
		</div>
	);
}

export default LoginRegister;
